import "./styles.scss";

import React, { useState, useRef } from "react";
import Slider from "react-slick";

const ClientsSlider = ({ lang }) => {
  const data = [
    {
      category: lang === "en" ? "Developers" : "Deweloperzy",
      slider: [
        {
          slides: [
            require("../../assets/img/mdd/clients/imperial-capital.png"),
            require("../../assets/img/mdd/clients/logo-home-dombud.png"),
            require("../../assets/img/mdd/clients/gorskie-resorty.png"),
            require("../../assets/img/mdd/clients/inwestor-property.png"),
            require("../../assets/img/mdd/clients/vanto-estate.png"),
            require("../../assets/img/mdd/clients/budrem.png"),
            require("../../assets/img/mdd/clients/trust-inw.png"),
            require("../../assets/img/mdd/clients/invest-house.png"),
            require("../../assets/img/mdd/clients/arkada.png"),
            require("../../assets/img/mdd/clients/odnova.png"),
            require("../../assets/img/mdd/clients/prato-development.png"),
            require("../../assets/img/mdd/clients/wl-inwest.png"),
          ],
        },
        {
          slides: [
            require("../../assets/img/mdd/clients/green-house-development.png"),
            require("../../assets/img/mdd/clients/des.png"),
            require("../../assets/img/mdd/clients/wik.png"),
          ],
        },
      ],
    },
    {
      category: lang === "en" ? "Sales offices" : "Biura sprzedaży",
      slider: [
        {
          slides: [
            require("../../assets/img/mdd/clients/privatehouse-1.png"),
            require("../../assets/img/mdd/clients/condo.png"),
            require("../../assets/img/mdd/clients/five-seasons.png"),
            require("../../assets/img/mdd/clients/morris-lloyd.png"),
            require("../../assets/img/mdd/clients/hoomvi.png"),
          ],
        },
      ],
    },
    {
      category: lang === "en" ? "Projects" : "Projekty",
      slider: [
        {
          slides: [
            require("../../assets/img/mdd/clients/city-lobzow.png"),
            require("../../assets/img/mdd/clients/mazowiecka-115.png"),
            require("../../assets/img/mdd/clients/green-park.png"),
            require("../../assets/img/mdd/clients/stawowa-residence.png"),
            require("../../assets/img/mdd/clients/noble-residence.png"),
            require("../../assets/img/mdd/clients/kapelanka-pychowicka.png"),
            require("../../assets/img/mdd/clients/osiedle-bogucianka.png"),
            require("../../assets/img/mdd/clients/zablocie-concept.png"),
            require("../../assets/img/mdd/clients/lipowa-5.png"),
            require("../../assets/img/mdd/clients/kazimierza-wielkiego-51.png"),
            require("../../assets/img/mdd/clients/unity-centre.png"),
            require("../../assets/img/mdd/clients/moja-klonowa.png"),
          ],
        },
        {
          slides: [
            require("../../assets/img/mdd/clients/nove-slichowice.png"),
            require("../../assets/img/mdd/clients/citi-yes.png"),
            require("../../assets/img/mdd/clients/sky-trust.png"),
            require("../../assets/img/mdd/clients/panorama-struga.png"),
            require("../../assets/img/mdd/clients/stacja-kopernik.png"),
            require("../../assets/img/mdd/clients/rezydencja-swierkowa.png"),
            require("../../assets/img/mdd/clients/rezydencja-swierkowa.png"),
            require("../../assets/img/mdd/clients/rezydencja-centrum.png"),
            require("../../assets/img/mdd/clients/krakowska-rogatka.png"),
            require("../../assets/img/mdd/clients/plaza-city.png"),
            require("../../assets/img/mdd/clients/rezydencja-sikorskiego.png"),
            require("../../assets/img/mdd/clients/art-garden.png"),
          ],
        },
        {
          slides: [
            require("../../assets/img/mdd/clients/hampton.png"),
            require("../../assets/img/mdd/clients/zalesie-corner.png"),
          ],
        },
      ],
    },
  ];

  const [category, setCategory] = useState(data[0].category);

  const sliderRef = useRef(null);
  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    draggable: true,
    slidesToShow: 1,
    autoplay: false,
    slidesToScroll: 1,
  };

  const isNavVisible =
    data?.filter((item) => item.category === category)?.[0].slider?.length > 1;

  return (
    <div className="clients-slider">
      <div className="clients-slider__categories">
        {data.map((item, index) => (
          <button
            className={`btn_custom${
              item.category === category ? " active" : ""
            }`}
            type="button"
            key={index}
            onClick={() => setCategory(item.category)}
          >
            {item.category}
          </button>
        ))}
      </div>
      <div className="clients-slider__nav">
        <button
          className="clients-slider__nav-arrow clients-slider__nav-arrow--prev"
          type="button"
          disabled={!isNavVisible}
          onClick={() => sliderRef.current.slickPrev()}
        >
          Poprzedni
        </button>
        <button
          className="clients-slider__nav-arrow clients-slider__nav-arrow--next"
          type="button"
          disabled={!isNavVisible}
          onClick={() => sliderRef.current.slickNext()}
        >
          Następny
        </button>
      </div>
      {data
        .filter((item) => item.category === category)
        .map((item, index) => (
          <Slider {...sliderSettings} key={index} ref={sliderRef}>
            {item.slider.map((item, index) => (
              <div key={index}>
                <div className="row align-items-center">
                  {item.slides.map((item, index) => (
                    <div
                      className="col-md-3 col-sm-4 col-6 clients-slider__col"
                      key={index}
                    >
                      <div className="clients-slider__logo">
                        <img src={item} alt="" />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </Slider>
        ))}
    </div>
  );
};

export default ClientsSlider;
